import React, { useState } from "react";
import styles from "./styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

import {
  Button,
  ClickAwayListener,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import ReactHtmlParser from "react-html-parser";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import imageUnico from "../../../assets/cards/unico.jpg";
import imageEsencial from "../../../assets/cards/esencial.jpg";
import imagePractico from "../../../assets/cards/practico.jpg";
import imageIdeal from "../../../assets/cards/ideal.jpg";
import imageElite from "../../../assets/cards/elite.jpg";
import imagePrivilegio from "../../../assets/cards/privilegio.jpg";
import imagePrivilegioPlus from "../../../assets/cards/privilegio-plus.jpg";
import imageExperienceWorld from "../../../assets/cards/experience-world.jpg";
import imageOncocare from "../../../assets/cards/oncocare.jpg";
import imageOncocareCun from "../../../assets/cards/oncocare-cun.jpg";
import imageRespaldoTotalInternacional from "../../../assets/cards/respaldo-total-internacional.jpg";
import imageRespaldoInternacional from "../../../assets/cards/respaldo-internacional.jpg";
import imageEcuadorMegaMenu from "../../../assets/images/cobertura_ecuador_mega_menu.jpg";
import imageEcuadorCunMegaMenu from "../../../assets/images/cobertura_mas_cun_mega_menu.jpg";
import imageCoverturaMundialMegaMenu from "../../../assets/images/cobertura_mundial_mega_menu.jpg";
import imageCancerCoverageMegaMenu from "../../../assets/images/cobertura_medica_frente_al_cancer.jpg";
import imageDentalCoverageMegaMenu from "../../../assets/images/cobertura_dental_mega_menu.jpg";
import experienceLogoMegaMenu from "../../../assets/images/experience_logo_mega_menu.svg";
import imageMajorCoverageMegaMenu from "../../../assets/images/respaldo_total.png";
import imageServicesMegaMenu from "../../../assets/images/servicios_adicionales.png";

const listPlans = [
  {
    id: 1,
    name: "Cobertura en Ecuador",
    title: "Planes médicos de cobertura local a tu alcance",
    children: [
      {
        id: 1,
        image: imageUnico,
        title: "Único",
        description:
          "Mejor cobertura médica de hasta <strong>$30.000</strong> a un costo accesible",
        arrowColor: "color-purple",
        url: "/plan-unico/"
      },
      {
        id: 2,
        image: imageEsencial,
        title: "Esencial",
        description: "Cobertura médica básica hasta <strong>$15.000</strong>",
        arrowColor: "color-blue",
        url: "/plan-esencial/"
      },
      {
        id: 3,
        image: imagePractico,
        title: "Práctico",
        description:
          "Mejor cobertura médica de hasta <strong>$30.000</strong> a un costo accesible",
        arrowColor: "color-orange",
        url: "/plan-practico/"
      },
      {
        id: 4,
        image: imageIdeal,
        title: "Ideal",
        description:
          "Cobertura médica de hasta <strong>$45.000</strong> y acceso a mejores prestadores médicos",
        arrowColor: "color-red",
        url: "/plan-ideal/"
      }
    ]
  },
  {
    id: 2,
    name: "Cobertura médica mundial",
    title:
      "Las mejores coberturas médicas locales con acceso y cobertura ilimitada en España y Colombia.",
    children: [
      {
        image: imageElite,
        title: "Élite",
        description:
          "Cobertuta médica local e Internacional, con acceso a prestadores médicos de prestigio.",
        arrowColor: "color-blue",
        url: "/plan-elite/"
      },
      {
        image: imagePrivilegio,
        title: "Privilegio",
        description:
          "La más alta Cobertura médica local, para proteger la salud de los que más amas.",
        arrowColor: "color-blue",
        url: "/plan-privilegio/"
      },
      {
        image: imagePrivilegioPlus,
        title: "Privilegio Plus",
        description:
          "La mejores coberturas médicas del país y acceso a la cobertura internacional ilimitada.",
        arrowColor: "color-blue",
        url: "/plan-privilegio-plus/"
      }
    ]
  },
  {
    id: 3,
    name: "Cobertura médica frente al cáncer",
    title:
      "Las mejores y más altas coberturas médicas nacionales e internacionales.",
    children: [
      {
        image: imageExperienceWorld,
        title: "Experience World",
        classTitle: "card-title-styles",
        description:
          "La mejor experiencia de servicio con cobertura médica de hasta <strong>$3’000.000</strong>",
        arrowColor: "color-blue",
        url: "/coberturanacionaleeuu/"
      }
    ]
  },
  {
    id: 4,
    name: "Cobertura de gastos mayores",
    title:
      "Las mejores y más altas coberturas médicas nacionales e internacionales.",
    children: [
      {
        image: imageExperienceWorld,
        title: "Experience World",
        classTitle: "card-title-styles",
        description:
          "La mejor experiencia de servicio con cobertura médica de hasta <strong>$3’000.000</strong>",
        arrowColor: "color-blue",
        url: "/coberturanacionaleeuu/"
      }
    ]
  },
  {
    id: 5,
    name: "Cobertura dental",
    title: "Cobertura limitada frente al cáncer",
    children: [
      {
        image: imageOncocare,
        title: "Plan Oncocare",
        description: "Te ofrecemos Cobertura Médica Ilimitada sin deducibles.",
        arrowColor: "color-blue",
        url: "/oncocare/"
      },
      {
        image: imageOncocareCun,
        title: "Oncocare CUN",
        description: "La mejor Cobertura frenre al cáncer en España.",
        arrowColor: "color-blue",
        url: "/oncocare-internacional/"
      }
    ]
  },
  {
    id: 6,
    name: "Servicios adicionales",
    title:
      "Las mejores coberturas médicas locales con acceso y cobertura ilimitada en España y Colombia.",
    children: [
      {
        image: imageRespaldoTotalInternacional,
        title: "Respaldo Total Nacional",
        description:
          "Estamos junto a ti en todo momento, ampliamos tu cobertura médica",
        arrowColor: "color-blue",
        url: "/respaldototal/"
      },
      {
        image: imageRespaldoInternacional,
        title: "Respaldo Total Internacional",
        description:
          "Ampliamos tu cobertura médica hasta <strong>1’000.000</strong> en la Clínica Universidad de Navarra.",
        arrowColor: "color-blue",
        url: "/respaldototal-internacional/"
      }
    ]
  }
  // {
  //   id: 6,
  //   name: "Cobertura dental",
  //   title: "Queremos verte siempre sonriendo",
  //   children: [
  //     {
  //       image: imageDentalEsencial,
  //       title: "Plan Dental Esencial",
  //       description: "Cobertura Odontológica a tu alcance",
  //       arrowColor: "color-blue",
  //       url: "/saludental-esencial/"
  //     },
  //     {
  //       image: imageDentalMaster,
  //       title: "Plan Dental Master",
  //       description: "Coberturas Odontológicas Básicas",
  //       arrowColor: "color-blue",
  //       url: "/saludental-master/"
  //     },
  //     {
  //       image: imageDentalPrivilegio,
  //       title: "Plan Dental Privilegio",
  //       description: "Cobertura Odontológica de Prestigio",
  //       arrowColor: "color-blue",
  //       url: "/saludental-privilegio/"
  //     }
  //   ]
  // },
  // {
  //   id: 7,
  //   name: "Servicios adicionales",
  //   title: "Amplia tu protección con nuestros servicios adicionales",
  //   children: [
  //     {
  //       image: imageSaludsaVida,
  //       title: "Saludsa Vida",
  //       arrowColor: "color-white",
  //       url: "/saludsavida/"
  //     },
  //     {
  //       image: imageSaludsaTravel,
  //       title: "Saludsa Travel",
  //       arrowColor: "color-white",
  //       url: "/saludsatravvel/"
  //     },
  //     {
  //       image: imageDesempleo,
  //       title: "Desempleo",
  //       arrowColor: "color-white",
  //       url: "/mas-servicios/"
  //     },
  //     {
  //       image: imageExequial,
  //       title: "Exequial",
  //       arrowColor: "color-white",
  //       url: "/exequial/"
  //     },
  //     {
  //       image: imageMuerteAccidental,
  //       title: "Muerte Accidental",
  //       arrowColor: "color-white",
  //       url: "/mas-servicios/"
  //     },
  //     {
  //       image: imageEnfermedadesGraves,
  //       title: "Enfermedades Graves",
  //       arrowColor: "color-white",
  //       url: "/mas-servicios/"
  //     }
  //   ]
  // }
  // {
  //   id: 8,
  //   name: "Comparar",
  //   title:
  //     "No sabes cual Plan es el indicado para ti, compara nuestros planes.",
  //   children: [
  //     {
  //       image: imageFamilia,
  //       title: "Compara y elige el mejor plan para ti y tu familia",
  //       arrowColor: "color-white",
  //       url: "/plan-elite/"
  //     }
  //   ]
  // }
];
export const MenuPlans = ({ handleClickAway, visible }) => {
  const classes = styles();
  const [selectedPlan, setSelectedPlan] = useState(1);
  const handleListItemClick = (event, index) => {
    setSelectedPlan(index);
  };

  const cardNationalCoverage = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div>
          <div
            className={classes.coberturaEcuadorMegaMenu}
            style={{
              backgroundImage: `url(${imageEcuadorMegaMenu})`
            }}
          >
            <div className={classes.contenedorCoberturaMegaMenuIzquierda}>
              <div className={classes.tituloContenedorCoberturaMegaMenu}>
                Ecuador
              </div>
              <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                Planes a tu alcance. Todos incluyen Vitality, DrSalud, hasta
                100% cobertura hospitalaria y 80% ambulatoria y más. Desde
                $24/mes
              </div>
              <div className={classes.coberturaMegaMenuLinksContainer}>
                <div className={classes.coberturaMegaMenuInternosLinks}>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/plan-unico/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                    >
                      Unico $7000
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/plan-esencial/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                    >
                      Esencial $15.000
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
                <div className={classes.coberturaMegaMenuInternosLinks}>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/plan-practico/`}
                    className={classes.linkPageCoberturaMegaMenu}
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                    >
                      Practico $30.000
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/plan-ideal/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                    >
                      Ideal $45.000
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className={classes.contenedorCoberturaMegaMenuDerecha}>
              <a
                href="/comparador/"
                className={`${classes.botonesCoberturaMegaMenu} ${classes.subtituloContenedorCoberturaMegaMenu}`}
              >
                Comparar
              </a>
              <a
                href="/todos-los-planes/"
                className={`${classes.botonesCoberturaMegaMenu} ${classes.subtituloContenedorCoberturaMegaMenu}`}
                style={{ backgroundColor: "transparent", marginTop: "10px" }}
              >
                Ver todos
              </a>
            </div>
          </div>
          <div
            className={classes.coberturaEcuadorMegaMenu}
            style={{
              backgroundImage: `url(${imageEcuadorCunMegaMenu})`,
              borderBottomRightRadius: "7px"
            }}
          >
            <div className={classes.contenedorCoberturaMegaMenuIzquierda}>
              <div className={classes.tituloContenedorCoberturaMegaMenu}>
                Ecuador y Clínica U. de Navarra
              </div>
              <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                Accede a los mejores prestadores médicos e importantes clínicas
                internacionales. Incluyen Vitality, DrSalud, cobertura ilimitada
                en la Clínica Universidad de Navarra, Saludsa Travel, entre
                otros. Desde $78
              </div>
              <div className={classes.coberturaMegaMenuLinksContainer}>
                <div
                  className={classes.coberturaMegaMenuInternosLinks}
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    marginTop: "15px"
                  }}
                >
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/plan-elite/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold" }}
                    >
                      Élite $100.000
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/plan-privilegio/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold" }}
                    >
                      Privilegio $1’000.000
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className={classes.contenedorCoberturaMegaMenuDerecha}>
              <a
                href="/comparador/"
                className={`${classes.botonesCoberturaMegaMenu} ${classes.subtituloContenedorCoberturaMegaMenu}`}
              >
                Comparar
              </a>
              <a
                href="/todos-los-planes/"
                className={`${classes.botonesCoberturaMegaMenu} ${classes.subtituloContenedorCoberturaMegaMenu}`}
                style={{ backgroundColor: "transparent", marginTop: "10px" }}
              >
                Ver todos
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const cardCoverages = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div
          className={classes.coberturaEcuadorMegaMenu}
          style={{
            backgroundImage: `url(${imageCoverturaMundialMegaMenu})`,
            minHeight: "260px",
            borderBottomRightRadius: "7px"
          }}
        >
          <div className={classes.megaMenuMedicaMundial}>
            <div>
              <img
                src={experienceLogoMegaMenu}
                alt="experience_logo_mega_menu"
              />
            </div>
            <div style={{ maxWidth: "340px" }}>
              <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                Experience World combina la mejor cobertura médica mundial con
                acceso a los principales hospitales del Ecuador y el mundo con
                una experiencia única de servicio.
              </div>
              <a
                href="https://www.experience.ec/"
                className={`${classes.botonesCoberturaMegaMenu} ${classes.megaMenuBotonExperience}`}
              >
                Conoce más
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const cardCancerCoverage = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div
          className={classes.coberturaEcuadorMegaMenu}
          style={{
            backgroundImage: `url(${imageCancerCoverageMegaMenu})`,
            minHeight: "260px",
            borderBottomRightRadius: "7px"
          }}
        >
          <div
            className={`${classes.megaMenuMedicaMundial} ${classes.megaMenuCoberturaFrenteCancer}`}
          >
            <div className={classes.tituloMegaMenuOncocare}>
              <span style={{ fontWeight: "normal" }}>Plan</span>Oncocare
            </div>
            <div className={classes.subtituloContenedorCoberturaMegaMenu}>
              Nuestro plan Oncocare te ofrece{" "}
              <span style={{ fontWeight: "bold" }}>
                cobertura médica ilimitada
              </span>{" "}
              frente al cáncer con acceso a los principales prestadores médicos
              del país.
            </div>
            <a
              href="/oncocare/"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.botonesCoberturaFrenteCancerMegaMenu}`}
            >
              Conoce más
            </a>
          </div>
        </div>
      </div>
    );
  };

  const cardMajorCoverage = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div
          className={classes.coberturaEcuadorMegaMenu}
          style={{
            backgroundImage: `url(${imageMajorCoverageMegaMenu})`,
            minHeight: "260px",
            borderBottomRightRadius: "7px"
          }}
        >
          <div
            className={`${classes.megaMenuMedicaMundial} ${classes.megaMenuCoberturaFrenteCancer}`}
          >
            <div className={classes.tituloMegaMenuOncocare}>
              <span style={{ fontWeight: "normal" }}>Respaldo</span>Total
            </div>
            <div className={classes.subtituloContenedorCoberturaMegaMenu}>
              Complementa tu cobertura actual con un plan Respaldo Total.Este
              plan ofrece una cobertura de hasta
              <span style={{ fontWeight: "bold" }}>1 Millón</span> con un
              deducible de $5.000 en caso de contraer una enfermedad grave.
            </div>
            <a
              href="/respaldototal/"
              className={`${classes.botonesCoberturaMegaMenu} ${classes.botonesCoberturaFrenteCancerMegaMenu}`}
            >
              Conoce más
            </a>
          </div>
        </div>
      </div>
    );
  };

  const cardDentalCoverage = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div
          className={classes.coberturaEcuadorMegaMenu}
          style={{
            backgroundImage: `url(${imageDentalCoverageMegaMenu})`,
            minHeight: "260px",
            borderBottomRightRadius: "7px"
          }}
        >
          <div
            className={`${classes.megaMenuMedicaMundial} ${classes.megaMenuCoberturaFrenteCancer}`}
          >
            <div className={classes.tituloMegaMenuOncocare}>
              <span style={{ fontWeight: "normal" }}>Salud</span>Dental
            </div>
            <div className={classes.subtituloContenedorCoberturaMegaMenu}>
              Tu salud dental también es importante. Nuestros planes te ofrecen
              cobertura de hasta 100% en los principales procedimientos dentales
              y te da acceso clínicas dentales y profesionales de prestigio en
              el país.{" "}
              <span style={{ fontWeight: "bold" }}>Desde $9.79/mes</span>
            </div>
            <div className={classes.linksCoberturaDentalMegaMenu}>
              <div className={classes.coberturaMegaMenuLinksContainer}>
                <div
                  className={classes.coberturaMegaMenuInternosLinks}
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    marginTop: "15px"
                  }}
                >
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/saludental-esencial/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold" }}
                    >
                      Esencial
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/saludental-master/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold" }}
                    >
                      Master
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href={`${process.env.REACT_APP_URL_HOST}/saludental-privilegio/`}
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold" }}
                    >
                      Privilegio
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const cardServices = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <div
          className={classes.coberturaEcuadorMegaMenu}
          style={{
            backgroundImage: `url(${imageServicesMegaMenu})`,
            minHeight: "300px",
            borderBottomRightRadius: "7px"
          }}
        >
          <div
            className={`${classes.megaMenuMedicaMundial} ${classes.megaMenuCoberturaFrenteCancer}`}
          >
            <div className={classes.tituloMegaMenuOncocare}>
              <span style={{ fontWeight: "normal" }}>Servicios</span>{" "}
              Adicionales
            </div>
            <div className={classes.subtituloContenedorCoberturaMegaMenu}>
              Complementa y amplia tu protección tus productos Saludsa con los
              mejores{" "}
              <span style={{ fontWeight: "bold" }}>servicios adicionales</span>.
            </div>
            <div className={classes.linksCoberturaDentalMegaMenu}>
              <div className={classes.coberturaMegaMenuLinksContainer}>
                <div
                  className={classes.coberturaMegaMenuInternosLinks}
                  style={{
                    flexDirection: "row",
                    marginTop: "15px",
                    display: "block"
                  }}
                >
                  <a
                    href="/saludsavida/"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold", padding: "5px 0px" }}
                    >
                      SaludsaVida
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="/saludsatravel/"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold", padding: "5px 0px" }}
                    >
                      SaludsaTravel
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="/mas-servicios/#enfermedadesgraves"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold", padding: "5px 0px" }}
                    >
                      EnfermedadesGraves
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
                <div
                  className={classes.coberturaMegaMenuInternosLinks}
                  style={{
                    flexDirection: "row",
                    marginTop: "15px",
                    display: "block",
                    marginLeft: "15px"
                  }}
                >
                  <a
                    href="/exequial/"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold", padding: "5px 0px" }}
                    >
                      Exequial
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="/mas-servicios/#desempleo"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold", padding: "5px 0px" }}
                    >
                      Desempleo
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="/mas-servicios/#muerteaccidental"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div
                      className={classes.subtituloContenedorCoberturaMegaMenu}
                      style={{ fontWeight: "bold", padding: "5px 0px" }}
                    >
                      MuerteAccidental
                    </div>
                    <span className={classes.iconoFlechaMegaMenu}>
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const cardBuy = plan => {
    return (
      <div className={classes.planMenuContainer}>
        <Typography component="p" className={classes.titleMenu}>
          {plan?.title}
        </Typography>
        <div className={classes.cardContainer}>
          {plan &&
            plan.children?.map((item, index) => (
              <div key={index} className={classes.linkStyle}>
                <div
                  className={`${classes.cardServicesMenu} ${classes.cardBuyMenu}`}
                >
                  <div className={classes.cardImageContainer}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className={classes.image}
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div
                      className={classes.descriptionImage}
                      style={{
                        color: "white",
                        marginBottom: "24px",
                        marginTop: "12px"
                      }}
                    >
                      {ReactHtmlParser(item?.title)}
                    </div>

                    <a href="#" className={classes.buttonBuy}>
                      Comparar
                    </a>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  };
  const card = () => {
    const plan = listPlans.find(p => p.id === selectedPlan);

    switch (selectedPlan) {
      case 1:
        return cardNationalCoverage(plan);
      case 2:
        return cardCoverages(plan);
      case 3:
        return cardCancerCoverage(plan);
      case 4:
        return cardMajorCoverage(plan);
      case 5:
        return cardDentalCoverage(plan);
      case 6:
        return cardServices(plan);
      default:
        return "";
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Grid
        container
        className={classes.absoluteSContainer}
        style={{ display: visible ? "flex" : "none" }}
      >
        <Grid
          container
          justify="flex-end"
          style={{ width: "290px", maxWidth: "290px" }}
        >
          <div className={classes.listContainer}>
            <List
              component="nav"
              aria-label="Lista de planes"
              className={classes.navContainer}
            >
              {listPlans.map(item => (
                <ListItem
                  button
                  key={item.id}
                  selected={selectedPlan === item.id}
                  onClick={event => handleListItemClick(event, item.id)}
                  className={classes.itemMenu}
                >
                  <ListItemText
                    className={classes.textItem}
                    primary={item.name}
                  />
                  {selectedPlan === item.id ? (
                    <ListItemIcon style={{ display: "contents" }}>
                      <ArrowForwardIosIcon className={classes.iconActive} />
                    </ListItemIcon>
                  ) : (
                    ""
                  )}
                </ListItem>
              ))}
            </List>
          </div>
        </Grid>
        <Grid style={{ width: "670px", maxWidth: "670px" }}>{card()}</Grid>
      </Grid>
    </ClickAwayListener>
  );
};

MenuPlans.propTypes = {
  handleClickAway: PropTypes.any,
  visible: PropTypes.any
};
